<template>
  <div class="group-listing">
    <div class="mb-12">
      <v-row class="flex-column flex-md-row">
        <v-col>
          <v-card-title
            class="display-2 letter-spacing-compact font-weight-bold mb-md-12 align-center"
          >
            {{ $route.params.id ? 'Edit' : 'New' }}
            {{ currentUser.role === 'tourist' ? 'Trip' : 'Group' }}
          </v-card-title>
        </v-col>
      </v-row>
      <validation-observer ref="validator">
        <v-form @submit.prevent="submit()">
          <v-container fluid class="mx-1060">
            <v-row>
              <v-col
                :class="['pr-md-7', 'pl-md-5']"
                :lg="rightDrawer.opened ? 12 : 6"
                :md="rightDrawer.opened ? 12 : 12"
              >
                <ValidationProvider
                  :name="currentUser.isTourist() ? 'trip_name' : 'first_name'"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-bind="
                      request.id ? { disabled: true, readonly: true } : {}
                    "
                    name="first_name"
                    :error-messages="errors"
                    v-model="request.member.first_name"
                    :label="
                      currentUser.isTourist() ? 'Trip Name' : 'First Name'
                    "
                    required
                  />
                </ValidationProvider>
              </v-col>
              <v-col
                :class="['pr-md-7', 'pl-md-5', forTouristOperator]"
                :lg="rightDrawer.opened ? 12 : 6"
                :md="rightDrawer.opened ? 12 : 12"
              >
                <ValidationProvider
                  name="last_name"
                  :rules="currentUser.isTourismOperator() ? 'required' : ''"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-bind="
                      request.id ? { disabled: true, readonly: true } : {}
                    "
                    name="last_name"
                    :error-messages="errors"
                    v-model="request.member.last_name"
                    label="Last Name"
                  />
                </ValidationProvider>
              </v-col>
              <v-col
                :class="['pr-md-7', 'pl-md-5', forTouristOperator]"
                :lg="rightDrawer.opened ? 12 : 6"
                :md="rightDrawer.opened ? 12 : 12"
              >
                <ValidationProvider
                  name="email"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-bind="
                      request.id ? { disabled: true, readonly: true } : {}
                    "
                    name="email"
                    :error-messages="errors"
                    v-model="request.member.email"
                    label="Email"
                    required
                  />
                </ValidationProvider>
              </v-col>
              <v-col
                :class="['pr-md-7', 'pl-md-5', forTouristOperator, forTourist]"
                :lg="rightDrawer.opened ? 12 : 6"
                :md="rightDrawer.opened ? 12 : 12"
              >
                <CountryField
                  v-bind="request.id ? { disabled: true, readonly: true } : {}"
                  name="country"
                  rules="required"
                  label="Country of Origin"
                  item-value="alpha2Code"
                  v-model="request.member.country_code"
                />
              </v-col>

              <v-col
                class="pr-md-7 pl-md-5"
                :lg="rightDrawer.opened ? 12 : 6"
                :md="rightDrawer.opened ? 12 : 12"
              >
                <DatePicker
                  name="check_in"
                  rules="required"
                  v-model="request.check_in"
                  label="Check in date"
                  class="mb-6"
                />
              </v-col>
              <v-col
                class="pr-md-7 pl-md-5"
                :lg="rightDrawer.opened ? 12 : 6"
                :md="rightDrawer.opened ? 12 : 12"
              >
                <DatePicker
                  name="check_out"
                  rules="required|after:@check_in,true"
                  v-model="request.check_out"
                  label="Check out date"
                  :min="request.check_in"
                  class="mb-6"
                />
              </v-col>
              <v-col
                :class="['pr-md-7', 'pl-md-5', forTouristOperator]"
                :lg="rightDrawer.opened ? 12 : 6"
                :md="rightDrawer.opened ? 12 : 12"
              >
                <ValidationProvider
                  v-if="request.member.hasOwnProperty('years_of_diving')"
                  name="diving_years"
                  rules="integer"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-bind="
                      request.id ? { disabled: true, readonly: true } : {}
                    "
                    name="years_of_diving"
                    :error-messages="errors"
                    v-model="request.member.years_of_diving"
                    label="Years of diving"
                  />
                </ValidationProvider>
              </v-col>
              <v-col
                :class="['pr-md-7', 'pl-md-5', forTouristOperator]"
                :lg="rightDrawer.opened ? 12 : 6"
                :md="rightDrawer.opened ? 12 : 12"
              >
                <ValidationProvider
                  v-if="request.member.hasOwnProperty('no_of_dives')"
                  name="diving_number"
                  rules="integer"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-bind="
                      request.id ? { disabled: true, readonly: true } : {}
                    "
                    name="no_of_dives"
                    :error-messages="errors"
                    v-model="request.member.no_of_dives"
                    label="Number of dives"
                  />
                </ValidationProvider>
              </v-col>
              <v-col
                :class="[forTourist, 'pr-md-7', 'pl-md-5']"
                :lg="rightDrawer.opened ? 12 : 6"
                :md="rightDrawer.opened ? 12 : 12"
                v-if="currentUser.isTourist()"
              >
                <ValidationProvider
                  name="tourism_operator"
                  label="Tourism operator"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-autocomplete
                    class="notranslate"
                    :menu-props="{ contentClass: 'notranslate' }"
                    v-model="request.tourism_operator_id"
                    :items="operators"
                    :multiple="false"
                    item-text="full_name"
                    item-value="id"
                    :error-messages="errors"
                    label="Operators"
                    append-icon="$expand"
                    color="black"
                    name="tourism_operator"
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-avatar>
                          <template v-if="typeof data.item !== Array">
                            <div
                              v-for="photo in data.item.media.photos"
                              :key="photo.id"
                            >
                              <img class="w-50px" :src="photo.url" />
                            </div>
                          </template>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="data.item.full_name"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-html="data.item.phone_number"
                          ></v-list-item-subtitle>
                          <v-list-item-subtitle
                            v-html="data.item.email"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </validation-observer>
      <v-card-actions class="flex-column flex-md-row px-5">
        <v-btn
          large
          color="white"
          class="elevation-1 font-weight-bold px-8 mr-10"
          min-width="275px"
          @click="goToList()"
        >
          Cancel
        </v-btn>
        <v-btn
          large
          color="primary"
          class="elevation-1 font-weight-bold px-8"
          min-width="275px"
          @click.prevent="submit()"
          :loading="request.submitting"
          :disabled="request.submitting || (!request.id && request.submitted)"
        >
          Done
        </v-btn>
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import Request from '@request/GroupRequest';
import Model from '@models/Group';
import UserModel from '@models/User';

export default {
  name: 'Create',
  metaInfo: {
    titleTemplate: '%s - Manage Group',
  },
  components: {
    DatePicker: () => import('@components/utilities/DatePicker'),
    CountryField: () => import('@components/utilities/CountryField'),
  },
  data() {
    return {
      request: new Request(this.$refs),
      group: {},
      model: new Model(),
      modelOperator: new UserModel({
        filters: {
          role: 'tourism-operator',
        },
      }),
      operators: [],
    };
  },
  methods: {
    async submit() {
      if (await this.$refs.validator.validate()) {
        if (
          !this.request.id ||
          (this.request.id && this.$refs.validator.flags.changed)
        ) {
          let response = await this.request.submit();

          if (response) {
            this.switchToMember(response.data.id);
          }
        }
      }
    },
    switchToMember(id = this.request.id) {
      this.$router.push({
        name: 'group-members',
        params: {
          id: id,
        },
      });
    },
    goToList() {
      if (this.$route.from && this.$route.from.name === 'groups') {
        this.$route.back();
        return;
      }
      this.$router.push({
        name: 'groups',
      });
    },
    async fetchOperatorsData() {
      let response = await this.modelOperator.get();
      if (response) {
        this.operators = response.data;
      }
    },
  },
  computed: {
    forTourist() {
      return this.currentUser.isTourist() ? 'd-block' : 'd-none';
    },
    forTouristOperator() {
      return this.currentUser.role === 'tourism-operator'
        ? 'd-block'
        : 'd-none';
    },
  },
  async mounted() {
    const self = this;
    if (this.currentUser.isTourist()) await this.fetchOperatorsData();
    if (this.$route.params.id) {
      let id = this.$route.params.id;
      let response = await this.model.findById(id);
      if (response) {
        let group = response.data;
        this.group = Object.assign(this.group, group);
        let newGroup = this.clone(group);
        newGroup.member = newGroup.lead;
        this.request.reinit(newGroup);
      }
    } else if (this.currentUser.isTourist()) {
      self.request.member.email = self.currentUser.email;
      self.request.member.no_of_dives = self.currentUser.no_of_dives ?? '';
      self.request.member.years_of_diving =
        self.currentUser.years_of_diving ?? '';
      self.request.member.country_code = self.currentUser.country_code ?? '';
    }
  },
};
</script>

<style scoped></style>
